<app-eca-modal-host [heading]="heading"
                    (saveClicked)="saveEngagement()"
                    (editClicked)="editEngagement()"
                    (cancelClicked)="cancelClicked()"
                    (helpClicked)="helpClicked()"
                    [isEditing]="editing"
                    [yesButtonIcon]="['far', 'save']"
                    [noButtonIcon]="['far', 'times']"
                    [editButtonIcon]="['far', 'edit']"
                    noButtonColour="transparent">
  <div class="container">
    <div class="container-fluid">
      <div class="row" *ngIf="showingHelp">
        <div class="col">
          <div class="alert alert-info">
            <div class="container-fluid">
              <div class="row">
                <div class="col-auto">
                  <fa-icon [icon]="['far', 'question-circle']" size="4x">  </fa-icon>
                </div>
                <div class="col">
                  <p>An operative may work for you on various projects (electrotechnical work installations) and they may also progress in skills and change Job Roles.</p>
                  <p>On this screen, you can record the operative's current role with the company and enter the date that this new role is effective from in the Start Date input. If the role is continuing you can leave the End Date input empty. </p>
                </div>
                <div class="col-auto">
                  <fa-icon [icon]="['far', 'times']" class="close" (click)="helpClicked()">  </fa-icon>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <app-engagement-history-editor [engagement]="engagement"
                                         [isEditing]="editing"
                                         [allJobLevels]="allJobLevels"
                                         [allCompanyJobTitles]="allCompanyJobTitles"
                                         [allJobTitles]="allJobTitles"
                                         [allOperativeTypes]="allOperativeTypes"
                                         [allBusinessUnits]="allBusinessUnits"
                                         [allEmploymentStatuses]="allEmploymentStatuses"
                                         [allRisks]="allRisks"
                                         [saveAttempted]="saveAttempted">
          </app-engagement-history-editor>
        </div>
      </div>
    </div>
  </div>
</app-eca-modal-host>
